import { usePopup } from "hooks/usePopup";
import { useMemo, useRef } from "react";
import productBaseService from "services/productBaseService";
import { Drawer } from "shared";
import {
  errorsProductBase,
  categoriesSelect,
  subCategoriesSelect
} from "utils";

import { buildProductBaseUpdatePayload } from "../../productBaseUpdatePayload";
import { Form } from "../Form";

const formatInitialValues = data => ({
  name: data?.name,
  purchaseTypeId: data?.purchaseType,
  status: data?.status,
  category: categoriesSelect.find(
    item => item.name.toLowerCase() === data?.category?.toLowerCase()
  )?.value,
  subCategory: subCategoriesSelect.find(
    item => item.name.toLowerCase() === data?.subCategory?.toLowerCase()
  )?.value,
  base64: data.image,
  productCategory: data.productCategory?.id,
  productSubCategory: data.productSubcategory?.id,
  isCertificateRequired: data.isCertificateRequired,
  barcode: data.barcode,
  isSanitized: data.classification?.isSanitized,
  isDiverse: data.classification?.isDiverse,
  isProcessed: data.classification?.isProcessed,
  isGreen: data.classification?.isGreen,
  unitWeight: data.unitWeight
});

export const ModalUpdateProductBase = ({
  isOpen,
  refresh,
  close,
  dataProduct,
  productCategoryData,
  productSubCategoryData
}) => {
  const formRef = useRef(null);
  const { addPopup } = usePopup();

  const initialValues = useMemo(
    () => formatInitialValues(dataProduct),
    [dataProduct]
  );

  const handleClose = () => {
    close({ isOpen: false, data: {} });
  };

  const onSubmit = async data => {
    try {
      await productBaseService.updateProductBase(
        buildProductBaseUpdatePayload({
          id: dataProduct.id,
          values: data,
          currentImage: dataProduct.image
        })
      );

      addPopup({
        type: "success",
        title: "Produto base atualizado com sucesso."
      });
      handleClose();
      refresh();
    } catch (error) {
      if (error?.response?.status !== 401) {
        addPopup({
          type: "error",
          title: errorsProductBase(error?.response?.data?.message?.trim())
        });
      }
    }
  };

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={handleClose}
      title="Editar Produto Base"
    >
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        ref={formRef}
        productCategoryData={productCategoryData}
        productSubCategoryData={productSubCategoryData}
      />
    </Drawer>
  );
};
